export default "__VITE_ASSET__Dg4gU7Oj__"